import React from 'react';
import { useShippingSimulator } from '../hooks/useShippingSimulator';

const ShippingResultContainer = () => {
	const { isOpen } = useShippingSimulator();

	if (!isOpen) return null;

	return (
		<table className="shippingTable vtex-store-components-3-x-shippingTable bt bb b--muted-4 c-muted-1 ph0 pv3 mt4 w-100">
			<thead className="shippingTableHead vtex-store-components-3-x-shippingTableHead dn">
				<tr className="shippingTableRow vtex-store-components-3-x-shippingTableRow">
					<th className="shippingTableHeadDeliveryName vtex-store-components-3-x-shippingTableHeadDeliveryName">
						Entrega
					</th>
					<th className="shippingTableHeadDeliveryEstimate vtex-store-components-3-x-shippingTableHeadDeliveryEstimate">
						Prazo
					</th>
					<th className="shippingTableHeadDeliveryPrice vtex-store-components-3-x-shippingTableHeadDeliveryPrice">
						Valor
					</th>
				</tr>
			</thead>
			<tbody className="shippingTableBody vtex-store-components-3-x-shippingTableBody">
				<tr className="shippingTableRow vtex-store-components-3-x-shippingTableRow">
					<td className="shippingTableCell shippingTableCellDeliveryName vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryName pv1 ph3 t-small">
						<label className="shippingTableLabel vtex-store-components-3-x-shippingTableLabel">
							<input
								className="shippingTableRadioBtn vtex-store-components-3-x-shippingTableRadioBtn mr4"
								name="shipping-option"
								type="radio"
								value="Econômico"
							/>
							Econômico
						</label>
					</td>
					<td className="shippingTableCell shippingTableCellDeliveryEstimate vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryEstimate pv1 ph3 t-small c-muted-2">
						Em até 3 dias úteis
					</td>
					<td className="shippingTableCell shippingTableCellDeliveryPrice vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryPrice pv1 ph3 t-small c-muted-2">
						<span className="currencyContainer vtex-store-components-3-x-currencyContainer">
							<span className="currencyCode vtex-store-components-3-x-currencyCode">R$</span>
							<span className="currencyLiteral vtex-store-components-3-x-currencyLiteral">&nbsp;</span>
							<span className="currencyInteger vtex-store-components-3-x-currencyInteger">7</span>
							<span className="currencyDecimal vtex-store-components-3-x-currencyDecimal">,</span>
							<span className="currencyFraction vtex-store-components-3-x-currencyFraction">73</span>
						</span>
					</td>
				</tr>
				<tr className="shippingTableRow vtex-store-components-3-x-shippingTableRow">
					<td className="shippingTableCell shippingTableCellDeliveryName vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryName pv1 ph3 t-small">
						<label className="shippingTableLabel vtex-store-components-3-x-shippingTableLabel">
							<input
								className="shippingTableRadioBtn vtex-store-components-3-x-shippingTableRadioBtn mr4"
								name="shipping-option"
								type="radio"
								value="Rápido"
							/>
							Rápido
						</label>
					</td>
					<td className="shippingTableCell shippingTableCellDeliveryEstimate vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryEstimate pv1 ph3 t-small c-muted-2">
						Em até 2 dias úteis
					</td>
					<td className="shippingTableCell shippingTableCellDeliveryPrice vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryPrice pv1 ph3 t-small c-muted-2">
						<span className="currencyContainer vtex-store-components-3-x-currencyContainer">
							<span className="currencyCode vtex-store-components-3-x-currencyCode">R$</span>
							<span className="currencyLiteral vtex-store-components-3-x-currencyLiteral">&nbsp;</span>
							<span className="currencyInteger vtex-store-components-3-x-currencyInteger">9</span>
							<span className="currencyDecimal vtex-store-components-3-x-currencyDecimal">,</span>
							<span className="currencyFraction vtex-store-components-3-x-currencyFraction">39</span>
						</span>
					</td>
				</tr>
				<tr className="shippingTableRow vtex-store-components-3-x-shippingTableRow">
					<td className="shippingTableCell shippingTableCellDeliveryName vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryName pv1 ph3 t-small">
						<label className="shippingTableLabel vtex-store-components-3-x-shippingTableLabel">
							<input
								className="shippingTableRadioBtn vtex-store-components-3-x-shippingTableRadioBtn mr4"
								name="shipping-option"
								type="radio"
								value="Loggi Expressa"
							/>
							Loggi Expressa
						</label>
					</td>
					<td className="shippingTableCell shippingTableCellDeliveryEstimate vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryEstimate pv1 ph3 t-small c-muted-2">
						Em até 2 dias úteis
					</td>
					<td className="shippingTableCell shippingTableCellDeliveryPrice vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryPrice pv1 ph3 t-small c-muted-2">
						<span className="currencyContainer vtex-store-components-3-x-currencyContainer">
							<span className="currencyCode vtex-store-components-3-x-currencyCode">R$</span>
							<span className="currencyLiteral vtex-store-components-3-x-currencyLiteral">&nbsp;</span>
							<span className="currencyInteger vtex-store-components-3-x-currencyInteger">10</span>
							<span className="currencyDecimal vtex-store-components-3-x-currencyDecimal">,</span>
							<span className="currencyFraction vtex-store-components-3-x-currencyFraction">30</span>
						</span>
					</td>
				</tr>
				<tr className="shippingTableRow vtex-store-components-3-x-shippingTableRow">
					<td className="shippingTableCell shippingTableCellDeliveryName vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryName pv1 ph3 t-small">
						<label className="shippingTableLabel vtex-store-components-3-x-shippingTableLabel">
							<input
								className="shippingTableRadioBtn vtex-store-components-3-x-shippingTableRadioBtn mr4"
								name="shipping-option"
								type="radio"
								value="Sedex"
							/>
							Sedex
						</label>
					</td>
					<td className="shippingTableCell shippingTableCellDeliveryEstimate vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryEstimate pv1 ph3 t-small c-muted-2">
						Em até 7 dias úteis
					</td>
					<td className="shippingTableCell shippingTableCellDeliveryPrice vtex-store-components-3-x-shippingTableCell vtex-store-components-3-x-shippingTableCellDeliveryPrice pv1 ph3 t-small c-muted-2">
						<span className="currencyContainer vtex-store-components-3-x-currencyContainer">
							<span className="currencyCode vtex-store-components-3-x-currencyCode">R$</span>
							<span className="currencyLiteral vtex-store-components-3-x-currencyLiteral">&nbsp;</span>
							<span className="currencyInteger vtex-store-components-3-x-currencyInteger">11</span>
							<span className="currencyDecimal vtex-store-components-3-x-currencyDecimal">,</span>
							<span className="currencyFraction vtex-store-components-3-x-currencyFraction">90</span>
						</span>
					</td>
				</tr>
			</tbody>
		</table>
	);
};

export default ShippingResultContainer;
